'use client'
// Types
import type { IFinding, IFindingStatus } from '@/types/appsec/finding'

// Components
import { Box } from '@/CommonComponents'
import SeverityFilter from './SeverityFilter'
// Hooks
import { useState, useEffect, useRef } from 'react'
// Constants
import type { ISeverity } from '@/types/severity'
import StatusFilter from './StatusFilter'
import RepositoryFilter from './RepositoryFilter'

const DEFAULT_STATUS: IFindingStatus = 'open'

interface IFindingFilterProps<T extends IFinding> {
  findings: T[]
  onChange: (filterCriteria: {
    severity: ISeverity | null
    status: IFindingStatus | null
    repository: string | null
  }) => void
}

export default function FindingFilter<T extends IFinding>({ findings, onChange }: IFindingFilterProps<T>) {
  const [filterCriteria, setFilterCriteria] = useState<{
    severity: ISeverity | null
    status: IFindingStatus | null
    repository: string | null
  }>({
    severity: null,
    status: DEFAULT_STATUS,
    repository: null,
  })
  const initialFilterApplied = useRef(false)

  useEffect(() => {
    if (!initialFilterApplied.current && findings.length > 0) {
      initialFilterApplied.current = true
      onChange(filterCriteria)
    }
  }, [findings, filterCriteria, onChange])
  const handleSeverityChange = (severity: ISeverity | null) => {
    const newFilterCriteria = { ...filterCriteria, severity }
    setFilterCriteria(newFilterCriteria)
    onChange(newFilterCriteria)
  }
  const handleStatusChange = (status: IFindingStatus | null) => {
    const newFilterCriteria = { ...filterCriteria, status }
    setFilterCriteria(newFilterCriteria)
    onChange(newFilterCriteria)
  }
  const handleRepositoryChange = (repository: string | null) => {
    const newFilterCriteria = { ...filterCriteria, repository }
    setFilterCriteria(newFilterCriteria)
    onChange(newFilterCriteria)
  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
      <RepositoryFilter findings={findings} filterCriteria={filterCriteria} onChange={handleRepositoryChange} />
      <SeverityFilter findings={findings} filterCriteria={filterCriteria} onChange={handleSeverityChange} />
      <StatusFilter findings={findings} filterCriteria={filterCriteria} onChange={handleStatusChange} />
    </Box>
  )
}
